import type { StudentPackagesReportItemDTO } from "../api/client";

function escapeCsvCell(value: string | number | null | undefined): string {
  const s = value == null ? "" : String(value);
  if (
    s.includes(",") ||
    s.includes('"') ||
    s.includes("\n") ||
    s.includes("\r")
  ) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
}

function downloadCsv(filename: string, rows: string[]) {
  const csv = rows.join("\n");
  const blob = new Blob([`\uFEFF${csv}`], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

function formatUnits(row: StudentPackagesReportItemDTO): {
  used: string;
  remaining: string;
} {
  if (row.unitType === "hour") {
    return {
      used: `${row.usedUnits} ຊົ່ວໂມງ`,
      remaining: `${row.remainingUnits} ຊົ່ວໂມງ`,
    };
  }
  return {
    used: String(row.usedUnits),
    remaining: String(row.remainingUnits),
  };
}

export function exportStudentPackagesReportCsv(
  rows: StudentPackagesReportItemDTO[],
) {
  const header = [
    "Member ID",
    "ນັກຮຽນ",
    "ແພັກເກດ",
    "ຄລາສ/ຮຽນ",
    "ຈ່າຍແລ້ວ (ກີບ)",
    "ຄ້າງຊຳລະ (ກີບ)",
    "ວັນທີຈ່າຍ",
    "ເຂົ້າແລ້ວ",
    "ຄົງເຫຼືອ",
    "ວັນໝົດອາຍຸ",
  ].join(",");

  const body = rows.map((row) => {
    const units = formatUnits(row);
    return [
      escapeCsvCell(row.memberId),
      escapeCsvCell(row.studentName),
      escapeCsvCell(row.packageName),
      escapeCsvCell(row.studyDescription),
      escapeCsvCell(row.paidAmount),
      escapeCsvCell(row.unpaidAmount),
      escapeCsvCell(row.paidAt ?? ""),
      escapeCsvCell(units.used),
      escapeCsvCell(units.remaining),
      escapeCsvCell(row.expireDate),
    ].join(",");
  });

  const stamp = new Date().toISOString().slice(0, 10);
  downloadCsv(`student-packages-report-${stamp}.csv`, [header, ...body]);
}

export function formatStudentPackageMoney(amount: number): string {
  return `${amount.toLocaleString()} ກີບ`;
}
